import React from 'react'
import CompanySetup from '../Pages/Company/CompanyInfo/CompanySetup'

function Companysetup() {
  return (
    <>
        <CompanySetup />
    </>
  )
}

export default Companysetup
